import { Link } from "react-router-dom";

const ROLES = [
  { title: "Senior Brand Designer", type: "Full-time · Chennai", desc: "Lead identity systems for premium clients across food, fashion and tech." },
  { title: "Performance Marketing Specialist", type: "Full-time · Chennai/Remote", desc: "Own Google + Meta ad accounts. Drive ROAS for 8-12 clients." },
  { title: "Reels Producer", type: "Full-time · Chennai", desc: "Concept, shoot and edit short-form for Instagram and YouTube." },
  { title: "Studio Manager", type: "Full-time · Chennai", desc: "Run our 1500 sqft cyclorama — bookings, equipment, client experience." },
];

export default function Careers() {
  return (
    <div data-testid="careers-page" className="pt-24">
      <section className="container mx-auto px-4 pt-16 pb-24 max-w-4xl">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-3">Careers</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter leading-none mb-6">
          Build the brands of <span className="text-gradient">tomorrow.</span>
        </h1>
        <p className="text-lg text-[#52525B] mb-12 max-w-2xl">
          We're a senior team that ships. If you love craft and care about results, you'll fit right in.
        </p>

        <div className="space-y-3">
          {ROLES.map((r) => (
            <div key={r.title} className="bg-white border border-zinc-200 hover:border-[#FF007F] rounded-2xl p-6 flex flex-wrap items-center justify-between gap-4 transition">
              <div>
                <div className="font-display font-bold text-xl">{r.title}</div>
                <div className="text-xs text-zinc-500 mt-1">{r.type}</div>
                <p className="text-sm text-zinc-600 mt-2 max-w-xl">{r.desc}</p>
              </div>
              <a href="mailto:careers@cftcreations.com" className="px-5 py-2.5 rounded-full bg-[#0A1128] text-white text-sm font-bold">Apply →</a>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-zinc-500 mb-3">Don't see your role?</p>
          <Link to="/contact" className="font-semibold text-[#FF007F]">Tell us why we should hire you →</Link>
        </div>
      </section>
    </div>
  );
}
